import React, { useCallback, useEffect, useState } from "react";
import { styled, useTheme, alpha } from '@mui/material/styles';
import { Box, Button, TextField } from "@mui/material";
import useSession from "../../SessionHook/SessionHook";
import { getIdentity } from "../../../commands/user/identity";
import { IdentityResult } from "../../../commands/APIResult";
import TwitterIcon from '@mui/icons-material/Twitter';
import { AvatarDropzone } from "./AvatarDropZone";
import { updateNickname } from "../../../commands/user/updateNickname";
import Avatar from '@mui/material/Avatar';
import { getLogins, LoginResult } from "../../../commands/user/getLogins";
import { Provider } from "@project-serum/anchor";
import Switch from '@mui/material/Switch';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import SpecialBtn from '../Mint/SpecialBtn';
import CancelIcon from '@mui/icons-material/Cancel';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import ConnectWallet from "../Mint/ConnectWallet";
import { signInWithTwitter, signOutFromTwitter } from "../../../commands/firebase/signInWithTwitter"
import { deleteLogin } from "../../../commands/user/deleteLogin";
import axios from 'axios';
import { getUserTwitterDetails } from "../../../commands/user/getUserTwitterDetails";
import Tooltip from '@mui/material/Tooltip';

type ProfileProps = {
    className?: string,
}

function Profile(props: ProfileProps) {

    const theme = useTheme();
    const { wallets, wallet: selected, publicKey, signMessage } = useWallet();

    const { hasSession, updateToken, getTBUid, token, clear } = useSession();

    const [name, setName] = useState<string>();
    const [nickname, setNickname] = useState<string>();
    const [createdAt, setCreatedAt] = useState();
    const [logins, setLogins] = useState<LoginResult[]>([]);
    const [pushNotification, setPushNotification] = useState<boolean>(false);

    const [editNickname, setEditNickname] = useState<boolean>(false);
    const [editNicknameVal, setEditNicknameVal] = useState<string>("");

    const [showNnEditIcon, setShowNnEditIcon] = useState<boolean>(false);
    const [showImgEditIcon, setShowImgEditIcon] = useState<boolean>(false);
    const [showImgDropzone, setShowImgDropzone] = useState<boolean>(false);

    const [twitterLogin, setTwitterLogin] = useState<LoginResult | null>(null);
    const [twitterUsername, setTwitterUsername] = useState<string | null>(null);



    useEffect(() => {

        console.log("logins");

        if (token)
            getLogins(token as string, getTBUid() as string).then((data: LoginResult[]) => {

                console.log("Logins", data)
                setLogins(data);

                let twLogin = data.find((el: any) => el.provider === 'twitter');

                if (twLogin) {
                    console.log("_we have twitter login");
                    setTwitterLogin(twLogin);
                    getAndSetTwitterUsername();
                }
            })

    }, [token]);


    useEffect(() => {

        console.log("PRIFIL")
        if (token)
            getIdentity(token as string).then((data: IdentityResult) => {

                if (data.nickname)
                    setNickname(data.nickname);

                if (data.name)
                    setName(data.name);

                //@ts-ignore
                setCreatedAt(data.createdAt);

            })

    }, [token]);

    let date = "No date";

    if (createdAt) {
        let d = new Date(parseInt(createdAt));
        date = d.toISOString().substring(0, 10);
    }

    let changeNnHandler = (e: any) => {
        // Up to 50 chars max!
        setEditNicknameVal(e.target.value.slice(0, 50));
    }

    //
    async function getAndSetTwitterUsername() {
        let res = await getUserTwitterDetails(token as string);

        if (res.data) {
            setTwitterUsername(res.data.username);
        }
    }

    let saveNickname = async (e: any) => {
        if (editNicknameVal.trim() !== "") {
            let res = await updateNickname(token as string, editNicknameVal.trim());

            if (res.status === 0) {
                setNickname(editNicknameVal);
                setEditNickname(false);
                setEditNicknameVal("");
            }
        }
    }

    let pushNotificationHandler = async (e: any) => {

        console.log(e);
        await updateNickname(token as string, editNicknameVal);
        setEditNickname(false);
        setEditNicknameVal("")
    }

    let afterImgUpload = async (e: any) => {
        setShowImgDropzone(false);
    }

    let connectTwiterBtnHandler = async (e: any) => {
        await signInWithTwitter(token as string);

        let data = await getLogins(token as string, getTBUid() as string);
        setLogins(data);

        let twLogin = data.find((el: any) => el.provider === 'twitter');

        if (twLogin) {
            console.log("_we have twitter login");
            setTwitterLogin(twLogin);
            getAndSetTwitterUsername();
        }
    }

    let disconnectTwiterBtnHandler = async (e: any) => {
        await signInWithTwitter(token as string);
    }

    let deleteLoginHandler = async (e: any) => {
        let login = logins.find((el: any) => el.provider === 'twitter');

        if (login) {
            await deleteLogin(login.provider, login.providerId, token as string);

            let data = await getLogins(token as string, getTBUid() as string);
            setLogins(data);

            let twLogin = data.find((el: any) => el.provider === 'twitter');

            if (twLogin === undefined) {
                setTwitterLogin(null);
                setTwitterUsername(null);
            }
        }
    }

    let onImgErrorHandler = async (e: any) => {
        const img = document.getElementById('profile-picture') as HTMLImageElement;
        const defaultImage = `${process.env.NEXT_PUBLIC_CDN_URL}/avatar/default_avatar.png`;

        if (img) {
            img.src = defaultImage;
            img.alt = 'default';
        }
    }

    //
    function avatarBtnUi(showImgEditIcon: boolean, showImgDropzone: boolean) {
        if (showImgEditIcon && !showImgDropzone) {
            return <BorderColorIcon onClick={() => setShowImgDropzone(true)} sx={{ position: "absolute", top: "15px", right: "15px", fontSize: "16px", cursor: "pointer", color: "#eee9e9" }} />
        }
        else if (showImgDropzone) {
            return (
                <>
                    <CancelIcon onClick={() => setShowImgDropzone(false)} sx={{ position: "absolute", top: "15px", right: "15px", fontSize: "19px", cursor: "pointer", color: "#bd1b38" }} />
                    <Box sx={{ position: "absolute", }}><AvatarDropzone afterUpload={afterImgUpload} /></Box>
                </>
            )
        }
    }

    //
    function avatarUi() {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative", margin: "25px 10px 10px 10px", }}
                onMouseEnter={() => setShowImgEditIcon(true)}
                onMouseLeave={() => setShowImgEditIcon(false)} >

                <img src={"/mint/Frame_Legendary.png"} style={{ width: "200px", height: "211px" }} />
                <img id="profile-picture" onError={onImgErrorHandler} src={`${process.env.NEXT_PUBLIC_CDN_URL}/avatar/${getTBUid()}`} style={{ position: "absolute", width: "186px", height: "186px", top: "11px" }} />

                {avatarBtnUi(showImgEditIcon, showImgDropzone)}
            </Box>
        )
    }

    //
    function editNicknameUI() {
        return (
            <>
                <TextField
                    sx={{ marginTop: "10px", "input": { color: 'white' }, ".MuiInput-underline": { borderBottom: "1px solid #c08531" } }}
                    onChange={(changeNnHandler)} value={editNicknameVal} id="standard-basic" label="" variant="standard" />

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Button onClick={() => { setEditNickname(false); setEditNicknameVal("") }} sx={{ fontSize: "10px", color: "#bd1b38", fontWeight: 700 }}>close</Button>
                    <Button onClick={saveNickname} sx={{ fontSize: "10px", color: "#14ae78", fontWeight: 700 }}>save</Button>
                </Box>
            </>
        )
    }

    //
    function nicknameUi() {
        return (
            <>
                {showNnEditIcon &&
                    <BorderColorIcon
                        onClick={() => { setEditNickname(true); setShowNnEditIcon(false) }}
                        sx={{ position: "absolute", top: "4px", right: "-5px", fontSize: "16px", cursor: "pointer", color: "#eee9e9" }} />}

                <span style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", display: "block" }}>{nickname}</span>
            </>
        )
    }

    //
    function mainUserInfoUi() {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", flexWrap: "wrap", width: "200px", maxWidth: "200px" }}>
                <Box sx={{ color: "#c08531", fontSize: "16px", fontWeight: 700, lineHeight: 1.2 }}>Dragoneer</Box>

                <Box sx={{ padding: "0px 13px 0px 13px", color: "white", fontSize: "20px", fontWeight: 500, display: "block", maxWidth: "200px", position: "relative" }}
                    onMouseEnter={() => setShowNnEditIcon(true)} onMouseLeave={() => { setShowNnEditIcon(false) }} >

                    {!editNickname && nicknameUi()}
                    {editNickname && editNicknameUI()}
                </Box>

                {false && <Box sx={{ marginTop: "20px", position: "relative", background: '#5e4732', borderRadius: "5px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", padding: "4px", width: "100px" }}>
                    <Box sx={{ position: "absolute", color: "#c08531", top: "1px", left: "4px", fontSize: "11px" }}>Born on</Box>
                    <Box sx={{ position: "relative", fontSize: "14px", color: "white", top: "4px" }}>{date}</Box>
                </Box>}

            </Box>
        )
    }

    function twitterButtonsUi(twLogin: LoginResult | null) {
        if (twLogin)
            return <SpecialBtn labelSize="14px" width="160px" height="36px" variant="blue" label="Disconnect" textColor={"white"} inProg={false} onClick={deleteLoginHandler} />
        else
            return <SpecialBtn labelSize="14px" width="160px" height="36px" variant="blue" label="Connect" textColor={"white"} inProg={false} onClick={connectTwiterBtnHandler} />
    }

    function userInfoUi() {
        return (
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexDirection: "column", padding: "10px", flexWrap: "wrap" }}>
                <Box sx={{ marginTop: "30px", width: "100%", display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "space-between" }}>
                    <Box sx={{ color: "#c08531", fontSize: "16px", fontWeight: 700, lineHeight: 1 }}>Push Notifications</Box>

                    <Box sx={{ color: "#c08531", fontSize: "16px", fontWeight: 700, lineHeight: 1 }}>
                        <Tooltip title="Coming soon" placement="top-start">
                            <span>
                                <Switch
                                    disabled={true}
                                    sx={{ ".MuiSwitch-switchBase.Mui-checked": { color: "white" }, ".MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": { background: "#12d40e" } }}
                                    checked={pushNotification}
                                    onChange={(e: any) => setPushNotification(e.target.checked)} />
                            </span>
                        </Tooltip>
                    </Box>

                </Box>

                <Box sx={{ marginTop: "0px", width: "100%", display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "space-between" }}>
                    <Box >
                        <Box sx={{ color: "#c08531", fontSize: "16px", fontWeight: 700, lineHeight: 1, marginRight: "10px" }}>Twitter: </Box>

                        <Box sx={{ color: "#c08531", fontSize: "16px", lineHeight: 1, marginRight: "20px" }}>
                            {twitterUsername ? twitterUsername : 'not connected'}
                        </Box>
                    </Box>

                    <Box sx={{ color: "#c08531", fontSize: "16px", lineHeight: 1 }}>
                        {twitterButtonsUi(twitterLogin)}
                    </Box>
                </Box>

                {true && <Box sx={{ marginTop: "10px", width: "100%", display: "flex", alignItems: "center" }}>
                    <Box sx={{ minWidth: 0, color: "#c08531", fontSize: "16px", fontWeight: 700, lineHeight: 1, marginRight: "10px" }}>Wallet: </Box>

                    <Box sx={{ diplay: "block", minWidth: 0, maxWidth: "200px", color: "#c08531", fontSize: "16px", lineHeight: 1.3, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                        {name}
                    </Box>
                </Box>}
            </Box >
        )
    }

    //
    function profileInnerUi() {
        return (
            <Box className="details-inner" sx={{ overflowY: "auto", height: "405px", marginTop: "70px", background: "" }}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row-reverse", flexWrap: "wrap", minWidth: 0 }}>
                    {avatarUi()}
                    {mainUserInfoUi()}
                </Box>

                {userInfoUi()}
            </Box>
        )
    }

    //
    function profileContainerUi() {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
                <Box sx={{
                    height: "600px", position: "relative", width: "50px",
                    backgroundImage: "url('/mint/Container_Inventory_Left_02.png')",
                    backgroundSize: "100% 100%",
                    flexShrink: 0
                }}>
                </Box>

                <Box sx={{
                    height: "600px", position: "relative",
                    backgroundImage: "url('/mint/Container_Inventory_Middle_02.png')",
                    backgroundSize: "100% 100%",
                    padding: "7px 0px 100px 0px"
                }}>
                    {/*headerUi()*/}
                    {profileInnerUi()}
                    {/*footerUi()*/}
                </Box>

                <Box sx={{
                    height: "600px", position: "relative", width: "50px",
                    backgroundImage: "url('/mint/Container_Inventory_Right_02.png')",
                    backgroundSize: "100% 100%",
                    flexShrink: 0
                }}>
                </Box>
            </Box>
        )
    }

    //
    return (
        <Box className={props.className}>
            {hasSession() && profileContainerUi()}

            {!hasSession() && <ConnectWallet ornament="/mint/Ornament_Light.png" btnTextColor="#333333" sx={{ marginTop: "10px" }}
                textColor="#d9d9d9" header="See your profile" body="Connect your wallet" />}
        </Box>
    )
}

const ProfileStyled = styled(Profile)(({ theme }) => ({
    border: "0px",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    backgroundImage: "url(/mint/BG_Cave.png)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 60%",
    padding: "120px 5px 0px 5px",
    ".game": {
        marginTop: '10%'
    },
    ".profile-box": {
        //position: "absolute", 
        marginTop: '10%',
        maxWidth: "650px",
        color: "white",
        fontWeight: 700,
        padding: "10px 10px 20px 10px",
        textAlign: "center",
        fontSize: "18px",
        textShadow: "3px 3px 3px #484848"
    },

    ".profile-text": {
        //position: "absolute",
        marginTop: '10%',
        maxWidth: "650px",
        color: "white",
        fontWeight: 700,
        textAlign: "left",
        fontSize: "18px",
        textShadow: "3px 3px 3px #484848"
    },
    ".details-inner": {
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "::-webkit-scrollbar-track": {
            background: "#896b53"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#b3957d"
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#b3957d"
        }
    },
}));

// Export
export default ProfileStyled;